import { GetTeamsOrderByOption } from '~/monolith-api';
import { getTeamsFromClient, searchTeamsFromClient, Team } from '~/pages/api/teams';
import { useIncrementalQuery, UseIncrementalQueryResult } from '~/queries';

const KEY = 'teams-search';
const DEFAULT_RESULT_LIMIT = 10;
export const MINIMUM_SEARCH_TERM_LENGTH = 4;

export function teamsSearchKey(searchTerm: string): [typeof KEY, string] {
   return [KEY, searchTerm];
}

export function useTeamsSearch(
   searchTerm: string,
   limit: number = DEFAULT_RESULT_LIMIT,
   ownerTeamUserid?: number,
   orderBy?: GetTeamsOrderByOption
): UseIncrementalQueryResult<Team[]> {
   return useIncrementalQuery(teamsSearchKey(searchTerm), async page => {
      if (searchTerm.length >= MINIMUM_SEARCH_TERM_LENGTH) {
         const { results: data, moreResults: hasMore } = await searchTeamsFromClient(searchTerm, {
            page: page,
            limit: limit,
            ownerTeamUserid: ownerTeamUserid,
         });
         return { data, hasMore, page };
      } else {
         const data = await getTeamsFromClient({
            limit: limit,
            offset: limit * (page - 1),
            ownerTeamUserid: ownerTeamUserid,
            orderBy: orderBy,
         });
         return { data, page, hasMore: data.length === limit };
      }
   });
}
